import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Ключ пропуска правки (§6.2) — id блока, человеку. `skipped` у правки пишется
 * только по `422` из плана, ключ — id блока как строка.
 *
 * Незнакомый формат отдаём как есть — то же правило, что у `imageTargetLabel`:
 * формат ключей задаёт бэк, и молчаливая пустая строка хуже сырого ключа.
 */
export const blockTargetLabel = (key: string): string =>
  /^\d+$/.test(key) ? messagesNow(messages).targetBlock(key) : key
